import { CompanyErrorNotificationModel } from 'src/Libs/company-settings/models'
import CompanySettingsUserDataModel from '../models/company-settings-user-data.model'
import { CompanyUserData } from 'src/State/User/UserModel'

const companyUserToCompanySettingsUser = (
  users: CompanyUserData[],
  errorNotificationForUser: CompanyErrorNotificationModel[]
): CompanySettingsUserDataModel[] => {
  return users.map(origin => {
    const userNotification = errorNotificationForUser.find(item => item.userId === origin.ID, null)

    return {
      ...origin,
      hasErrorNotification: Boolean(userNotification),
      errorNotificationId: userNotification?.id || null,
    }
  }) as CompanySettingsUserDataModel[]
}

export default companyUserToCompanySettingsUser
